import React from "react"

function IconStatusAway({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="status-away"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-status-away"
      {...props}
    >
      <path
        d="M21.823 12.084c0 5.469-4.434 9.903-9.902 9.903-5.471 0-9.903-4.434-9.903-9.903a9.9 9.9 0 0 1 9.903-9.902c5.468 0 9.902 4.432 9.902 9.902"
        fill={color}
        style={{ height: height || fontSize }}
        originalclass="__warning"
      />
      <path
        d="M13.225 8.558a1.42 1.42 0 0 0-2.839 0V12.1c0 .45.214.875.577 1.142l4.332 3.194a1.42 1.42 0 0 0 1.684-2.284l-3.754-2.769V8.558z"
        fill={color2 || color}
        fillRule="nonzero"
      />
    </svg>
  )
}

export default IconStatusAway
